//@flow
import React from 'react';

type Props = {
  initialShowList?:boolean,
  children?:React$Node[],
  name:string,
  controlId?:string,
};

type State = {
  showList:boolean,
  listClass:string,
};

export default class FilterList extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props);

    const listClass = props.initialShowList ? 'filters' : 'filters-fade-in';

    this.state = {
      showList: props.initialShowList || false,
      listClass,
    };
  }

  _getArrow() {
    const className = this.state.showList ? 'icon-up-arrow' : 'icon-down-arrow';
    return <span className={className}></span>;
  }

  _getListId() {
    return `${this.props.name} filters`;
  }

  _renderList() {
    if (!this.state.showList) return null;

    return (
      <ul
        className={this.state.listClass}
        id={this._getListId()}
      >
        {this.props.children}
      </ul>
    );
  }

  // toggle expanding list when enter or space is pressed
  _handleKeyDown = (event:KeyboardEvent) => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.preventDefault(); // prevent scrolling on spacebar press
      this._toggleShow();
    }
  }

  _toggleShow = () => {
    if (this.state.showList) {
      this.setState({ showList: false, listClass: 'filters-fade-in' });
    } else {
      this.setState({ showList: true });
      setTimeout(this.setState.bind(this, { listClass: 'filters' }), 50);
    }
  }

  render() {
    return (
      <div className="filter-list">
        <div
          aria-controls={this.props.controlId || this.props.name}
          aria-expanded={this.state.showList}
          onClick={this._toggleShow}
          onKeyDown={this._handleKeyDown}
          role="button"
          tabIndex="0"
          className="filters-header-holder"
        >
          <h3 className="filters-header">{this.props.name}{this._getArrow()}</h3>
        </div>
        {this._renderList()}
      </div>
    );
  }
}
